import {Report} from 'powerbi-client';
import {applyTheme, embedReport} from '@/components/pages/ReportView/report';
import {SphereReport} from '@/stores/apolloPlatform/cores/portalNavigation';

export function useReportEmbed(reportId: string, report: SphereReport, isMobile: Ref<boolean>) {
  const loading = ref(true);
  const errorMessage = ref<string>();

  let embed: Report;
  const loaded = computed(() => loading.value === false && embed !== undefined);

  const createReport = () => {
    loading.value = true;
    try {
      embed = embedReport(reportId, report, isMobile.value);
      embed.on('loaded', async () => {
        const iframe = document
          .getElementById(reportId)
          ?.querySelector('iframe') as HTMLIFrameElement;
        iframe.setAttribute('data-hj-allow-iframe', 'true'); // Hotjar
        const pages = await embed.getPages();
        if (pages.length > 0) iframe.style.height = `${pages[0]?.defaultSize.height}px`;
        await applyTheme(embed);
        loading.value = false;
      });
    } catch (error: any) {
      errorMessage.value = error;
      loading.value = false;
    }
  };

  let timeOut = 0;
  const startTimeOut = () => {
    const expiry = new Date(report.token.tokenExpiry).getTime() - Date.now();
    timeOut = window.setTimeout(createReport, expiry);
  };

  onMounted(() => {
    createReport();
    startTimeOut();
  });
  onUnmounted(() => clearTimeout(timeOut));

  onActivated(() => {
    loading.value = true;
    startTimeOut();
  });
  onDeactivated(() => clearTimeout(timeOut));

  const userSettingsStore = useUserSettingsStore();
  watch(
    () => [userSettingsStore.userSettings.theme, userSettingsStore.userSettings.colorblind],
    () => applyTheme(embed),
  );

  watch(isMobile, async () => {
    createReport();
    // TODO: Keep for later when Ben figures this out.
    // const pages = await embed.getPages();
    // const activePage = pages.find((page) => page.isActive);
    // Bizarre bug where a report has MobilePortrait, whereas hasLayout() will only have MobileLandscape...
    // const hasMobilePortrait = await activePage?.hasLayout(2);
    // if (newValue && hasMobilePortrait) createReport();
    // else if (newValue === false && hasMobilePortrait) createReport();
  });

  return {loaded, errorMessage, getEmbed: () => embed};
}
